import { get, create, update, remove } from "@/utill/getData";

export function getOrgnList(filter) {
  if (filter) {
    return get(`/orgns?orgnName=${filter.orgnName}&useYn=${filter.useYn}`);
  } else {
    return get("/orgns");
  }
}

export function addOrgn(param) {
  return create("/orgns", param);
}

export function updateOrgn(param) {
  return update(`/orgns/${param.orgnId}`, param);
}

export function removeOrgn(orgnId) {
  return remove(`/orgns/${orgnId}`);
}
